var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c("div", { staticClass: "modal-card-body has-text-centered" }, [
      _vm.firmador.selected == "signar" || _vm.firmador.selected == "signar_v3"
        ? _c("img", {
            staticClass: "image is-centered my-4",
            attrs: { src: "/statics/signar-logo.svg", width: "100", alt: "" },
          })
        : _vm.firmador.selected == "pfdrar"
        ? _c("img", {
            staticClass: "image is-centered my-4",
            attrs: { src: "/statics/pfdrar-logo.png", width: "100", alt: "" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-4" }, [
        _vm._v(_vm._s(_vm.firmador.title)),
      ]),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "notification" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmador.selected == "signar" || _vm.firmador.selected == "signar_v3"
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c("p", [
                _vm._v("Si el firmador\n        "),
                _c("u", [_vm._v("NO")]),
                _vm._v(
                  " se ejecutó, verifique si el navegador está bloqueando los pop-ups, deshabilitelos y "
                ),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.retrySignar(_vm.urlSignar)
                      },
                    },
                  },
                  [_c("u", [_vm._v("haga click aquí")])]
                ),
                _vm._v(" para volver a intentar\n      "),
              ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("p", [
                _vm._v("¿No cuenta con " + _vm._s(_vm.firmador.name) + "?"),
                _c("br"),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.firmador.downloadLink,
                      target: "_blank",
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-download" }),
                    _vm._v(" Descárguelo aquí"),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.firmador.selected == "signar_v3"
                ? _c(
                    "b-notification",
                    {
                      attrs: {
                        type: "is-warning",
                        "has-icon": "",
                        closable: false,
                        role: "alert",
                      },
                    },
                    [
                      _c("br"),
                      _vm._v(
                        "Ante cualquier inconveniente recomendamos utilizar el firmador por defecto (Signar® Firmador).\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.firmador.selected == "signar"
                ? _c("p", [
                    _vm._v("¿Está ingresando desde un dispositivo Android?"),
                    _c("br"),
                    _vm._m(2),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.firmador.selected == "signar"
                ? _c("p", { staticClass: "is-size-7" }, [
                    _vm._v(
                      "Si desea, puede utilizar al versión Legacy (JNLP) "
                    ),
                    _c("a", { on: { click: _vm.preparePilaJNLP } }, [
                      _vm._v("haciendo clic aquí"),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "notification is-warning" }, [
              _vm._v(
                "\n        El firmador no se encuentra disponible para su uso\n      "
              ),
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-centered" }, [
        _c(
          "a",
          {
            staticClass: "button is-dark",
            on: {
              click: function ($event) {
                return _vm.$parent.close()
              },
            },
          },
          [_vm._v("\n          Cerrar\n        ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "button is-primary", on: { click: _vm.reloadUrl } },
          [
            _c("i", { staticClass: "fas fa-redo" }),
            _vm._v(" Recargar pagina\n        "),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticClass: "animated flash infinite slower has-text-primary" },
      [
        _c("i", { staticClass: "fas fa-spin fa-sync" }),
        _vm._v(" Conectando con el servidor, un momento..."),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Recomendamos habilitar los pop-ups en Signar®")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        attrs: {
          href: "https://play.google.com/store/apps/details?id=ar.com.helenasoftware.signar",
          target: "_blank",
        },
      },
      [
        _c("i", { staticClass: "fas fa-download" }),
        _vm._v(" Descargue la Aplicación y vuelva a intentar"),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Si el firmador\n        "),
      _c("u", [_vm._v("NO")]),
      _vm._v(
        " se ejecutó, verifique si su navegador está bloqueando los pop-ups\n      "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Recomendamos habilitar los pop-ups en Signar®")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }